module.exports = __webpack_public_path__ + "img/foundationIllustrationGenericInformation@3x.4c95078d.png";